import React from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { NotificationProvider } from "./context/NotificationContext";
import { createTheme } from "./styles/theme/create-theme";
import App from "./App";
import { LoaderProvider } from "./context/LoaderContext";
import { BrowserRouter } from "react-router-dom";
import store from "./store";
import { Provider } from "react-redux";
import { ModalProvider } from "./context/ModalContext";
import { MessagesProvider } from "./context/MessagesContext";
import { SnackbarProvider } from "./context/SnackbarContext";
import { SnackbarProvider as NotistackProvider } from "notistack";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { TimezoneProvider } from "./context/TimezoneContext";
import "./styles/global.css";

const container = document.getElementById("app");
const root = createRoot(container!);
const theme = createTheme();
const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <TimezoneProvider>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <BrowserRouter>
            <ThemeProvider theme={theme}>
              <NotificationProvider>
                <NotistackProvider maxSnack={3} preventDuplicate>
                  <SnackbarProvider>
                    <LoaderProvider>
                      <ModalProvider>
                        <MessagesProvider>
                          <CssBaseline />
                          <App />
                        </MessagesProvider>
                      </ModalProvider>
                    </LoaderProvider>
                  </SnackbarProvider>
                </NotistackProvider>
              </NotificationProvider>
            </ThemeProvider>
          </BrowserRouter>
        </Provider>
      </QueryClientProvider>
    </TimezoneProvider>
  </React.StrictMode>
);
